import { useId, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Redux.
import { connect } from "react-redux";
import {
    setNextPreviewsInfo,
} from '../redux/actions/dataActions';

// Components
import { loadTrack } from './audioHelper';

import PreviewInfo from './PreviewInfo';
import { eventPreviewView } from './eventHelper';
import { recordForMePreviewSeen } from '../redux/actions/forMePreferenceActions';
import { isPlayableChatPreview, playableChatPreviews } from '../utils/chatPreviewQueue';
import { getPreviewTopic } from '../utils/previewTopic';
import { rememberForYouPreviewOrigin } from '../utils/askNavigation';


export const PreviewInfosVertical = ({
    previews,
    title,
    previewInfoProps = {},
    previewItemClassName = '',
    queueChatResponse = false,
    queueDisplayedTopic = false,
    playbackOrigin,

    // Redux.
    authenticated,
    uid,
    recordForMePreviewSeen = () => {},
    setNextPreviewsInfo,

}) => {
    const componentId = useId();

    const viewedIdsRef = useRef(new Set());

    const navigate = useNavigate();
    const location = useLocation();
    const playsTopicQueue = queueDisplayedTopic && !queueChatResponse;

    const indexInViewport = (index) => {
        if (index >= 0 && index < previews.length) {
            const previewId = previews[index].id;
            if (!viewedIdsRef.current.has(previewId)) {
                viewedIdsRef.current.add(previewId);
                if (authenticated) recordForMePreviewSeen(uid, previewId);
                eventPreviewView(previewId, 0);
            }
        }
    }

    const playPreview = (preview) => () => {
        if (!isPlayableChatPreview(preview)) return;
        const nextPreviewsInfo = playsTopicQueue ? [preview] : playableChatPreviews(previews);
        if (!nextPreviewsInfo.some(item => item.id === preview?.id)) return;
        if (playsTopicQueue) rememberForYouPreviewOrigin(location, preview.id);
        loadTrack(preview.mp3URL, 0);
        const topic = playsTopicQueue ? getPreviewTopic(preview, { uppercase: false }) : '';
        if (playsTopicQueue) {
            setNextPreviewsInfo(authenticated, [preview], {
                initialPreviewId: preview.id,
                relatedPreviewId: preview.id,
                relatedTopicId: topic || undefined,
            });
        } else if (queueChatResponse) {
            setNextPreviewsInfo(authenticated, nextPreviewsInfo, {
                initialPreviewId: preview.id,
                relatedPreviewId: preview.id,
                playbackSource: 'chat',
                responsePreviewIds: nextPreviewsInfo.map(item => item.id),
            });
        } else {
            setNextPreviewsInfo(authenticated, nextPreviewsInfo, {
                initialPreviewId: preview.id,
                playbackOrigin,
                allowRelatedPreviews: false,
            });
        }
        navigate('/previews', { state: { closeAllModal: true, title: topic || title } });
    }

    const listPreviewInfoProps = {
        ...previewInfoProps,
        bodyPaddingBottom: 0,
        className: [
            previewInfoProps.className,
            'previewInfoVerticalListCard',
        ].filter(Boolean).join(' '),
    };

    return (
        <div>
            <div>
                {!previews ?
                    <div style={{ padding: '20px' }}>Unexpected error, please try again later.</div>
                    :
                    <div id={componentId} className='previewInfosVerticalList'>
                        {previews.map((preview, previewIndex) => (
                            <div
                                key={preview.id}
                                data-for-you-preview-id={playsTopicQueue ? preview.id : undefined}
                                className={[
                                    'previewInfosVerticalItem',
                                    previewItemClassName,
                                ].filter(Boolean).join(' ')}>
                                <PreviewInfo
                                    preview={preview}
                                    playPreview={playPreview(preview)}
                                    index={previewIndex}
                                    indexInViewport={indexInViewport}
                                    {...listPreviewInfoProps}
                                    onTopicPlay={playPreview(preview)}
                                    topicActionLabel={queueChatResponse ? 'Play preview from your answer' : listPreviewInfoProps.topicActionLabel}
                                />
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
    uid: state.user.uid,
});

const mapActionsToProps = {
    setNextPreviewsInfo,
    recordForMePreviewSeen,
};

export default connect(mapStateToProps, mapActionsToProps)(PreviewInfosVertical);
